// extracted by mini-css-extract-plugin
module.exports = {"title":"Articles_title__OLwH1","head":"Articles_head__8jPxZ","articleGrid":"Articles_articleGrid__rqvOJ","card":"Articles_card__iMYYE"};